<div class="dropdown">
  <!-- Search input -->
  <div class="input-container">
    <input
      type="text"
      [(ngModel)]="searchTerm"
      (input)="filterOptions()"
      (focus)="showDropdown()"
      (blur)="hideDropdown()"
      placeholder="Search by name, surname, role, or company..."
      class="dropdown-input"
    />
    <span class="dropdown-icon" [ngClass]="{'active': dropdownVisible}">
      {{ dropdownVisible ? '▲' : '▼' }}
    </span>
  </div>

  <!-- Dropdown menu -->
  <ul class="dropdown-menu" *ngIf="dropdownVisible && filteredOptions.length > 0">
    <li
      *ngFor="let client of filteredOptions"
      class="dropdown-item"
      (click)="toggleSelection(client, $event)"
    >
      <!-- Checkbox for multi-select -->
      <input
        type="checkbox"
        [checked]="isSelected(client)"
        (click)="toggleSelection(client, $event)"
      />
      <!-- Display: Name Surname - Role (Company if exist) -->
      {{ client.name }} {{ client.surname }} - {{ client.role }}
      <span *ngIf="client.company">({{ client.company }})</span>
    </li>
  </ul>
</div>

<!-- Display selected items (chips) -->
<div class="selected-list" *ngIf="selectedClients.length > 0">
  <span *ngFor="let client of selectedClients" class="chip">
    {{ client.name }} {{ client.surname }} - {{ client.role }}
    <span *ngIf="client.company">({{ client.company }})</span>
    <!-- Remove button -->
    <button (click)="toggleSelection(client)">x</button>
  </span>
</div>
